<app-navbar></app-navbar>


<div class="gestionar-inventario-container">

  <app-detail (hostingSelected)="onHostingSelectedFromDetail($event)"></app-detail>

  <h1>Gestionar Inventario</h1>

  <div *ngIf="cargando; else contenido">
    <p class="mensaje-cargando">Cargando alojamientos...</p>
  </div>

  <ng-template #contenido>
    <div >
      <p>Selecciona el alojamiento</p>
      <ul class="alojamientos-list">
        <li *ngFor="let alojamiento of alojamientos"
            (click)="seleccionarAlojamiento(alojamiento)"
            (keydown.enter)="seleccionarAlojamiento(alojamiento)"
            class="alojamiento-item">
          
          {{ alojamiento.name }} - {{ alojamiento.title }} - {{ alojamiento.type }}

          <!-- Mostrar opciones solo si este alojamiento es el seleccionado -->
          <div *ngIf="alojamientoSeleccionado?.id === alojamiento.id" class="opciones">        
            <button (click)="irAGestionarProductos()" class="btn-gestionar-productos">
              Gestionar productos
            </button>    
          </div>
        </li>
      </ul>    
    </div>
  </ng-template>

  <ng-template #noAlojamientos>
    <p>No hay alojamientos creados.</p>
  </ng-template>

</div>
<app-footer></app-footer>